import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "./Navbar";

const EMAIL = "vmdpproject@gmail.com";
const PIVA = "10990261215";
const UPDATED = "Giugno 2026";

/* ─── Sezione testo legale ─── */
function Section({ n, title, children }) {
  return (
    <div
      style={{
        marginBottom: "2.75rem",
        paddingBottom: "2.75rem",
        borderBottom: "1px solid var(--color-border)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "1rem",
        }}
      >
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "0.7rem",
            fontWeight: 500,
            color: "var(--color-accent-mid)",
            background: "rgba(124,58,237,0.1)",
            border: "1px solid rgba(124,58,237,0.22)",
            borderRadius: "6px",
            padding: "3px 9px",
            flexShrink: 0,
          }}
        >
          {String(n).padStart(2, "0")}
        </span>
        <h2
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 700,
            fontSize: "clamp(1.3rem, 2.5vw, 1.6rem)",
            color: "var(--color-text)",
            letterSpacing: "-0.01em",
            margin: 0,
          }}
        >
          {title}
        </h2>
      </div>
      <div
        style={{
          color: "var(--color-text-2)",
          fontSize: "1rem",
          lineHeight: 1.85,
        }}
      >
        {children}
      </div>
    </div>
  );
}

const linkStyle = {
  color: "var(--color-accent-mid)",
  textDecoration: "underline",
  textUnderlineOffset: "3px",
};
const ulStyle = {
  paddingLeft: "1.25rem",
  margin: "0.75rem 0",
  display: "flex",
  flexDirection: "column",
  gap: "0.4rem",
};

export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
        style={{ background: "var(--color-bg)", minHeight: "100vh" }}
      >
        {/* ── Hero ── */}
        <section
          style={{
            paddingTop: "68px",
            background:
              "linear-gradient(180deg, rgba(124,58,237,0.08) 0%, transparent 100%)",
            borderBottom: "1px solid var(--color-border)",
          }}
        >
          <div className="container" style={{ padding: "4rem 1.75rem 3rem" }}>
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-accent-mid)",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                display: "block",
                marginBottom: "1rem",
              }}
            >
              {"// termini e condizioni"}
            </span>
            <h1
              style={{
                fontFamily: "var(--font-display)",
                fontWeight: 800,
                fontSize: "clamp(2.2rem, 5vw, 3.2rem)",
                letterSpacing: "-0.03em",
                lineHeight: 1.1,
                marginBottom: "1rem",
              }}
            >
              Termini e{" "}
              <span
                style={{
                  background: "var(--gradient-text)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Condizioni
              </span>
            </h1>
            <p
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-muted)",
              }}
            >
              VMDProject · vmdproject.com · Ultimo aggiornamento: {UPDATED}
            </p>
          </div>
        </section>

        {/* ── Contenuto ── */}
        <div className="container" style={{ padding: "3rem 1.75rem 5rem" }}>
          {/* Intro card */}
          <div
            style={{
              background: "rgba(124,58,237,0.06)",
              border: "1px solid rgba(124,58,237,0.2)",
              backdropFilter: "blur(12px)",
              borderRadius: "var(--radius-lg)",
              padding: "1.5rem 1.75rem",
              marginBottom: "3rem",
              color: "var(--color-text-2)",
              fontSize: "1rem",
              lineHeight: 1.8,
            }}
          >
            I presenti Termini e Condizioni regolano l'utilizzo del sito web{" "}
            <strong style={{ color: "var(--color-text)" }}>
              vmdproject.com
            </strong>{" "}
            e delle relative pagine di presentazione dei prodotti VMDProject.
            Leggili attentamente prima di utilizzare il sito.
          </div>

          <Section n={1} title="Accettazione dei Termini">
            Utilizzando il sito vmdproject.com, l'utente accetta i presenti
            Termini e Condizioni nella loro interezza. Se non accetti questi
            termini, ti invitiamo a non utilizzare il sito. VMDProject si
            riserva il diritto di modificare i presenti Termini in qualsiasi
            momento; le modifiche saranno pubblicate su questa pagina con
            aggiornamento della data.
          </Section>

          <Section n={2} title="Descrizione del Sito">
            vmdproject.com è il sito di presentazione di{" "}
            <strong style={{ color: "var(--color-text)" }}>VMDProject</strong>,
            sviluppatore software indipendente con sede a Napoli (P.IVA {PIVA}),
            specializzato in applicazioni web, mobile e SaaS verticali. Il sito
            include la presentazione dei prodotti sviluppati (iCoach, CrewBoat,
            iPairly), un modulo di richiesta collaborazione e informazioni sui
            servizi offerti.
          </Section>

          <Section n={3} title="Utilizzo del Sito">
            L'utente si impegna a utilizzare il sito esclusivamente per scopi
            leciti e nel rispetto delle leggi vigenti. Sono vietati:
            <ul style={ulStyle}>
              <li>
                Tentativi di accesso non autorizzato ai sistemi informatici del
                sito.
              </li>
              <li>
                Invio di messaggi di spam, contenuti offensivi o illeciti
                tramite i moduli presenti.
              </li>
              <li>
                Attività che possano compromettere la funzionalità o la
                sicurezza del sito.
              </li>
              <li>
                Raccolta automatizzata di dati (scraping) senza autorizzazione
                scritta.
              </li>
            </ul>
          </Section>

          <Section n={4} title="Proprietà Intellettuale">
            Tutti i contenuti presenti su vmdproject.com — inclusi testi,
            immagini, loghi, design, codice sorgente, presentazioni dei prodotti
            e materiali grafici — sono di esclusiva proprietà di{" "}
            <strong style={{ color: "var(--color-text)" }}>VMDProject</strong> o
            dei rispettivi licenziatari e sono protetti dalla normativa italiana
            ed europea sul diritto d'autore e sulla proprietà industriale.
            <br />
            <br />È vietata qualsiasi riproduzione, distribuzione, modifica o
            utilizzo commerciale senza espressa autorizzazione scritta
            preventiva. Per richieste di utilizzo dei contenuti:{" "}
            <a href={`mailto:${EMAIL}`} style={linkStyle}>
              {EMAIL}
            </a>
            .
          </Section>

          <Section
            n={5}
            title="Modulo di Contatto e Richieste di Collaborazione"
          >
            Il modulo di collaborazione è fornito a scopo di comunicazione
            commerciale e richieste di sviluppo software. VMDProject si impegna
            a rispondere entro 48 ore lavorative. I dati inseriti nel modulo
            vengono trattati secondo la{" "}
            <Link to="/policy" style={linkStyle}>
              Privacy Policy
            </Link>
            . L'invio del modulo non costituisce accettazione di alcun
            contratto; ogni collaborazione viene definita e formalizzata
            separatamente.
          </Section>

          <Section n={6} title="Limitazione di Responsabilità">
            Nei limiti consentiti dalla legge applicabile, VMDProject non sarà
            responsabile per danni diretti o indiretti derivanti da:
            <ul style={ulStyle}>
              <li>L'utilizzo o l'impossibilità di utilizzo del sito.</li>
              <li>Errori, omissioni o imprecisioni nei contenuti del sito.</li>
              <li>L'accesso a siti terzi tramite link presenti nel sito.</li>
              <li>
                Interruzioni del servizio per manutenzione o cause di forza
                maggiore.
              </li>
            </ul>
            Il sito è fornito "così com'è". VMDProject non garantisce la
            continuità del servizio né l'assenza di errori tecnici.
          </Section>

          <Section n={7} title="Link a Siti Terzi">
            Il sito può contenere link a siti web di terze parti (App Store,
            Google Play, LinkedIn, GitHub, ecc.). VMDProject non è responsabile
            del contenuto, delle politiche sulla privacy o delle pratiche di
            tali siti. L'accesso a siti terzi avviene a esclusivo rischio
            dell'utente.
          </Section>

          <Section n={8} title="Cookie Policy">
            Il sito utilizza esclusivamente cookie tecnici necessari al
            funzionamento. Il consenso viene richiesto tramite il banner cookie
            integrato nel sito. L'utente può accettare o rifiutare i cookie non
            tecnici in qualsiasi momento tramite il banner. Per maggiori
            dettagli consulta la{" "}
            <Link to="/policy" style={linkStyle}>
              Privacy Policy
            </Link>
            .
          </Section>

          <Section n={9} title="Termini dei Singoli Prodotti">
            Ogni prodotto presentato nel sito dispone di propri Termini e
            Condizioni specifici:
            <ul style={ulStyle}>
              <li>
                <Link to="/icoach/terms" style={linkStyle}>
                  iCoach — Termini e Condizioni
                </Link>
              </li>
              <li>
                <Link to="/crewboat/terms" style={linkStyle}>
                  CrewBoat — Termini e Condizioni
                </Link>
              </li>
              <li>
                <Link to="/ipairly/terms" style={linkStyle}>
                  iPairly — Termini di Servizio
                </Link>
              </li>
            </ul>
          </Section>

          <Section n={10} title="Esclusione di Garanzie">
            Nei limiti consentiti dalla legge, VMDProject esclude qualsiasi
            garanzia esplicita o implicita relativa al sito e ai suoi contenuti,
            incluse garanzie di commerciabilità, idoneità a uno scopo specifico
            e non violazione di diritti di terzi.
          </Section>

          <Section n={11} title="Legge Applicabile e Foro Competente">
            I presenti Termini e Condizioni sono regolati dalla legge italiana.
            Per qualsiasi controversia derivante dall'utilizzo del sito è
            competente in via esclusiva il{" "}
            <strong style={{ color: "var(--color-text)" }}>
              Tribunale di Napoli
            </strong>
            , salvo diversa previsione obbligatoria di legge a tutela del
            consumatore.
          </Section>

          <Section n={12} title="Contatti">
            Per qualsiasi domanda relativa ai presenti Termini e Condizioni:
            <br />
            <br />
            <strong style={{ color: "var(--color-text)" }}>VMDProject</strong> —
            Napoli, Italia
            <br />
            P.IVA: {PIVA}
            <br />
            Email:{" "}
            <a href={`mailto:${EMAIL}`} style={linkStyle}>
              {EMAIL}
            </a>
          </Section>

          {/* Navigazione legale */}
          {/* <div style={{
            display: 'flex', gap: '1rem', flexWrap: 'wrap',
            justifyContent: 'space-between', alignItems: 'center',
            marginTop: '1rem', paddingTop: '2.5rem',
            borderTop: '1px solid var(--color-border)',
          }}>
            <Link to="/" className="btn-primary">← Torna alla Home</Link>
            <Link to="/policy" style={linkStyle}>← Privacy Policy</Link>
          </div> */}
        </div>

        {/* ─── Footer ─── */}
        <footer
          style={{
            borderTop: "1px solid var(--color-border)",
            padding: "2rem 0",
          }}
        >
          <div
            className="container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <span
              style={{
                fontFamily: "var(--font-display)",
                fontWeight: 700,
                fontSize: "0.95rem",
              }}
            >
              VMDProject
            </span>
            <div style={{ display: "flex", gap: "1.5rem" }}>
              <Link
                to="/policy"
                style={{
                  fontSize: "0.9rem",
                  color: "var(--color-muted)",
                  transition: "color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.color = "var(--color-text)")
                }
                onMouseLeave={(e) =>
                  (e.target.style.color = "var(--color-muted)")
                }
              >
                Privacy
              </Link>
              <Link
                to="/terms-and-conditions"
                style={{ fontSize: "0.9rem", color: "var(--color-accent-mid)" }}
              >
                Termini
              </Link>
            </div>
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-muted)",
              }}
            >
              © {new Date().getFullYear()} VMDProject
            </span>
          </div>
        </footer>
      </motion.main>
    </>
  );
}
